import Vue from 'vue'
import HomeRouter from './router/home-router'
import NewRouter from './router/news-router'
import AboutRouter from './router/about-router'
import WebsiteRouter from './router/website-router'
import TeacherlistRouter from './router/teacher-router'
import Yunqiao from './router/yunqiao-router'

export default [
  ...HomeRouter,
  ...NewRouter,
  ...AboutRouter,
  ...WebsiteRouter,
  ...TeacherlistRouter,
  ...Yunqiao
]

